// extracted by mini-css-extract-plugin
export default {"container":"Io-z","heading":"Jo-z","text":"Ko-z","info":"Lo-z","link":"Mo-z","fullMaxWidth":"No-z"};